export const normalizeAxiosResponse = (response) => {
  const { data, status, ...rest } = response
  return {
    status,
    data,
    ...rest,
  }
}
